























import { store } from '@/store';
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class extends Vue {
  @Prop({ required: true })
  prevLevelName!: string
}
